var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C10.4844 6 6 10.4844 6 16V32C6 37.5156 10.4844 42 16 42H32C37.5156 42 42 37.5156 42 32V16C42 10.4844 37.5156 6 32 6H16ZM16 10H32C35.3086 10 38 12.6914 38 16V32C38 35.3086 35.3086 38 32 38H16C12.6914 38 10 35.3086 10 32V16C10 12.6914 12.6914 10 16 10ZM34 12C32.8945 12 32 12.8945 32 14C32 15.1055 32.8945 16 34 16C35.1055 16 36 15.1055 36 14C36 12.8945 35.1055 12 34 12ZM24 14C18.4844 14 14 18.4844 14 24C14 29.5156 18.4844 34 24 34C29.5156 34 34 29.5156 34 24C34 18.4844 29.5156 14 24 14ZM24 18C27.3086 18 30 20.6914 30 24C30 27.3086 27.3086 30 24 30C20.6914 30 18 27.3086 18 24C18 20.6914 20.6914 18 24 18Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0b7fe6a4cb8cbc535f73051b04cdfd9c.svg";
export { ForwardRef as ReactComponent };